export enum EurekaVersion {
    FREE = 'free',
    AIR = 'air',
    IP = 'ip',
    PROTECT = 'protect',
    MATERIAL = 'material',
    INSIGHTS = 'insights',
    LS = 'ls'
}

export enum EditionType {
    /**
     * 老
     */
    FREE = 'free',
    PREMIUM = 'premium',

    /**
     * 新
     */
    OVERLIMIT_RECOMMAND = 'overlimit' // 次数用量超限推荐卡片
}

export enum UpgradeUsageType {
    ONBOARDING = 'onboarding',
    TRY_PREMIUM = 'tryPremium',
    TRIAL_END = 'trialEnd'
}

export enum UsageAmountWhere {
    TECH_RESEARCH = 'technical_research',
    TECH_MIND = 'tech_mind',
    TECH_RISK = 'tech_fmea',
    IDEA = 'idea',
    PROJECT = 'project',
    TRIZ = 'triz',
    AGENTIC = 'agentic',
    RESULT = 'result'
}

export const AIR_UPGRADE_EVENT_TYPE = 'SS Eureka Upgrade Page';

// 升级所有埋点source_type
export enum BiTrackPoint {
    AIR_ONBOARDING_UPGRADE_CLICK = 'AIR-onboarding-upgrade-click', // onbording场景触发的升级
    AIR_USAGE_UPGRADE_SHOW = 'AIR-usage-upgrade-show', // 免费版使用量超限弹出
    AIR_USAGE_UPGRADE_CLICK = 'AIR-usage-upgrade-click', // 免费版使用量超限触发的升级
    AIR_HEADER_UPGRADE_CLICK = 'AIR-header-upgrade-click', // 试用版侧栏的主动升级
    AIR_BANNER_UPGRADE_CLICK = 'AIR-banner-upgrade-click', // 试用版横幅的主动升级
    AIR_TRIALEND_UPGRADE_CLICK = 'AIR-trialend-upgrade-click', // 试用版到期弹窗触发的升级
    AIR_USERSETTING_UPGRADE_SHOW = 'AIR-usersetting-upgrade-show', // 用户设置版本页面的显示
    AIR_USERSETTING_UPGRADE_CLICK = 'AIR-usersetting-upgrade-click', // 用户设置版本页面的升级
    AIR_UPGRADE_CLUEREPORT_SUBMIT = 'AIR-upgrade-cluereport-submit', // 中国区升级线索提交成功
    AIR_UPGRADE_UNLOCK_FORM_SHOW = 'AIR-upgrade-unlock-form-show', // 升级解锁表单展示
    AIR_UPGRADE_UNLOCK_FORM_SUBMIT = 'AIR-upgrade-unlock-form-submit' // 升级解锁表单提交
}

/**
 * 用量受限错误码列表
 * techSeek: 90164076
 * techMind: 90164072
 * techRisk: 90164082
 * Triz: 1510001001 || 90210004
 * techResearch: 90112037
 * idea: 90112019
 * roadmap 90110403
 */
export const EDITION_LIMIT_ERROR_CODES = [90110403, 90112037, 90164072, 90164076, 90164082, 1510001001, 90180009, 90112019, 90210004];

/**
 * 判断用量受限
 * @param code 错误码
 * @returns 是否为用量受限错误
 */
export function prepareInterceptorEdition(code: number | string) {
    return EDITION_LIMIT_ERROR_CODES.includes(Number(code));
}
